module.exports = __webpack_public_path__ + "img/error-alert-icon.e193f4ba.svg";